import state from "../state";

export default {
  topluislemStokListesi({ commit }, payload) {
    commit('TOPLU_ISLEM_STOK_LISTESI', payload)
  },
  topluislemNetsisfaturaAktarim({ commit }, payload) {
    commit(' NETSIS_FATURA_MUTATE', payload)
  },
  pazaryerSiparisDetayCek({ commit }, payload) {
    var vm = this;
    vm.veriler = [];
    const soap = require("soap");
    const url = state.sistemAddress;
    const args = {
      program: payload.siparisDetails.pazaryeri,
      orderNumber: payload.siparisDetails.orderNumber,
    };
    soap.createClient(url, function (err, client) {
      client.dbPazaryeriSiparisDetay(args, function (err, result) {
        if (result.dbPazaryeriSiparisDetayResult == "-1") {
          Store.dispatch("logout");
          //this.$store.dispatch('login', payload)
        }
        vm.veriler = JSON.parse(JSON.stringify(result.dbPazaryeriSiparisDetayResult));
        console.log(vm.veriler)
        commit(vm.veriler)
        //  return vm.veriler

        if (vm.veriler.response == "Ok") {


          // alert("ok")

        } else {
          //alert("Veriler Çekilemedi");
        }
      });
    });

  },
  pazaryerSiparisCek({ commit }, payload) {
    var vm = this;
    vm.veriler = [];
    const soap = require("soap");
    const url = state.sistemAddress;
    const args = {
      program: payload.siparisDetails.pazaryeri,
      orderNumber: payload.siparisDetails.orderNumber,
    };
    return new Promise((resolve, reject) => {
      soap.createClient(url, function (err, client) {
        client.pazaryeriTamamlananSiparisCek(args, function (err, result) {
          if (result.pazaryeriTamamlananSiparisCekResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.pazaryeriTamamlananSiparisCekResult);
          resolve(vm.veriler)
          if (vm.veriler.response == "Ok") {
            // alert("ok")
          } else {
            //alert("Veriler Çekilemedi");
          }
        })
      });
    })
  },
}